/**
 * Homey Admin V2 API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Which billing provider the manual subscription is recorded under. Only the two real providers: `deferred` is a trial placeholder, not something a paid user can be on.
 */
export interface MarkUserAsPaidCommandDto { 
    type: MarkUserAsPaidCommandDto.TypeEnum;
}
export namespace MarkUserAsPaidCommandDto {
    export const TypeEnum = {
        stripe: 'stripe',
        revenue_cat: 'revenue-cat'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


